import type { InjectionKey, Ref } from 'vue'

/**
 * App-wide loading-id registry. Provided once at the app root by
 * `LoadingProvider` (`@gat-ship/vue-components`) and consumable by any
 * layer via this key — including feature datasources/model code that must
 * not import the UI package to call `useAppLoading()`. The structural shape
 * mirrors `useAppLoading()`'s return value.
 */
export interface AppLoadingContext {
  loadingIds: Ref<Set<string>>
  setLoadingId: (id?: string | string[]) => void
  removeLoadingId: (id?: string | string[]) => void
  isLoading: (id?: string | string[]) => boolean
}

export const appLoadingKey = Symbol(
  'gs-app-loading'
) as InjectionKey<AppLoadingContext>
